import { useRef, useEffect } from 'react';

const useCloseByClickOutside = (elementRef, callback, closeByClickOutsideEnabled) => {
    const clickOutsideRef = useRef(false);
    const callbackRef = useRef(callback);
    useEffect(() => {
        callbackRef.current = callback;
    }, [callback]);
    useEffect(() => {
        if (!closeByClickOutsideEnabled) {
            return void 0;
        }
        const handleMouseDown = (event) => {
            clickOutsideRef.current = elementRef.current !== null && !elementRef.current.contains(event.target);
        };
        const handleClick = (event) => {
            if (clickOutsideRef.current) {
                clickOutsideRef.current = false;
                callbackRef.current(event);
            }
        };
        document.addEventListener('mousedown', handleMouseDown);
        document.addEventListener('click', handleClick);
        return () => {
            document.removeEventListener('mousedown', handleMouseDown);
            document.removeEventListener('click', handleClick);
        };
        // eslint-disable-next-line disable-autofix/react-hooks/exhaustive-deps
    }, [closeByClickOutsideEnabled]);
};

export { useCloseByClickOutside };
//# sourceMappingURL=useCloseByClickOutside.js.map
